import * as yup from 'yup';

export const updateFvValidate = yup.object({
  paymentTo: yup.string(),
  createdAt: yup.date(),
  number: yup.string().required('Numer FV jest wymagany'),
  price: yup.string().required('Kwota jest wymagana'),
});
